import { Pipe, PipeTransform, Injectable } from '@angular/core';

// @Pipe({
//   name: 'filter'
// })
@Injectable({
  providedIn: 'root'
})
// export class FilterPipe implements PipeTransform {

//   transform(list: any, property: string, operator: string, filter: string, chars?: number): any[] {
//     const compare = {
//       '=': (a, b) => a === b,
//       '!': (a, b) => a !== b
//     };
//     return filter ? list.filter(item => compare[operator](item[property].slice(0, chars).toLowerCase(), filter)) : list;
//   }

// }


@Pipe({ name: 'customDate' })
export class CustomDatePipe implements PipeTransform {
  transform(date, dayOffset) {
    const originalDate = new Date(date)
    return originalDate.setDate(originalDate.getDate() + dayOffset);
  }
}
